export default __webpack_public_path__ + "c7a7c10d547dc099010b5fd6e82792a8.png";